<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=this.windowHash>
</sub-header>
<p-scrollPanel [style]="{width: '100%', height: '70vh'}" styleClass="custombar1">
  <div class="container-fluid ">
    <div class="row">
      <blockquote>{{ 'TemplateGeneration.step3Help' | translate }}</blockquote>
      <ng-container>
        <!-- DIVISION -->
        <div class="plycaFormField col-12">
          <label for="divisionsControl">{{ 'TemplateGeneration.step1Name' | translate }}: {{
            'TemplateGeneration.step1Description' | translate }}</label>
          <formElement [model]="model" [fieldConfig]="getBuscadorDivisionTree()" (valueChanged)="onChangeDivision()">
          </formElement>
        </div>
      </ng-container>
      <!-- TIPO DE DOCUMENTO -->
      <div class="plycaFormField col-12">
        <label>{{ 'TemplateGeneration.step2Name' | translate }}: {{ 'TemplateGeneration.step2Description' | translate
          }}</label>
        <formElement [model]="model" [fieldConfig]="getBuscadorTipoDocumentosConfig()" (valueChanged)="loadTemplates()">
        </formElement>
      </div>
      <!-- TEMPLATE -->
      <div class="plycaFormField col-12">
        <label for="divisionsControl">{{ 'TemplateGeneration.step3Name' | translate }}: {{
          'TemplateGeneration.step3Description' | translate }}</label>
        <formElement [model]="model" [fieldConfig]="getTemplatesConfig()" (valueChanged)="this.selectTemplate()">
        </formElement>
      </div>
      <!-- PARAMETROS ADICIONALES (DIVISION, EMPRESA, OTROS PARAMETROS) -->
      <ng-container *ngIf="
        isDivisionSelectionEnabled() ||
        isCompanySelectionEnabled() ||
        (filteredParams && filteredParams.length > 0)
      ">
        <label>{{ 'TemplateGeneration.step4Name' | translate }}: {{ 'TemplateGeneration.step4Description' | translate
          }}</label>
        <!-- DIVISION -->
        <ng-container *ngIf="isDivisionSelectionEnabled()">
          <div class="plycaFormField col-12">
            <label for="divisionsControl">División:</label>
            <div class="p-inputgroup ">
              <input [value]="model.division?.name" disabled="true" class="plForm-element" pInputText
                autocomplete="off" />
            </div>
          </div>
        </ng-container>
        <!-- PARAMETROS DE LA PLANTILLA (FIJAMOS LOTEID E INCLUIMOS UNO ESPECIFICO SI SE PIDE EMPRESADNICIF-->
        <ng-container *ngIf="isCompanySelectionEnabled()">
          <div class="plycaFormField col-12"></div>
          <formElement [model]="model" [fieldConfig]="getCompanySearchFieldConfig()">
          </formElement>
        </ng-container>
        <div class="col-12" *ngIf="filteredParams && filteredParams.length > 0">
          <p-table [value]="filteredParams">
            <ng-template pTemplate="header">
              <tr>
                <th>Parámetro</th>
                <th>Valor</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-param>
              <tr>
                <td>{{ param.name }}</td>
                <td>
                  <input [ngModel]="param.value ? param.value : ''" (input)="param.value = $event.target.value"
                    class="plForm-element" [ngModelOptions]="{ standalone: true }" pInputText autocomplete="off" />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </ng-container>
    </div>
  </div>
</p-scrollPanel>